module.exports = __webpack_public_path__ + "img/3.c1715eb0.jpg";